import { TEMP_ASSIGNMENT_BASE_SCHEDULE_DONE_MESSAGE, TEMP_ASSIGNMENT_BASE_SCHEDULE_MISSING_MESSAGE } from "../messageConstants";
import { isBaseScheduleAdded } from "../taedUtils";

var FlexSearch = require("flexsearch");

var index;

export function initializeSearchIndex(tempAssignments) {
  
  index = new FlexSearch({
    doc: {
      id: "referenceNumber",
      profile: "speed",
      field: {
        searchFormat:{
          employee: {},
          startDate: {},
          endDate: {},
          lastUpdated: {},
        },
        workgroup: {},
        homeStation: {},
        tempStation: {},
        status: {},
        baseSchedule: {},
      },
    },
  });

  index.add(tempAssignments);
}

export function searchTempAssignments(searchString, applySearchCallback) {
  if (index) {
    let result = index.where(
      function (item) {

        if (item.searchFormat.employee.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        if (item.searchFormat.startDate.includes(searchString)) {
          return true;
        }

        if (item.searchFormat.endDate.includes(searchString)) {
          return true;
        }

        if (item.searchFormat.lastUpdated.includes(searchString)) {
          return true;
        }

        if (item.workgroup.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        if (item.homeStation.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        if (item.tempStation.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        if (item.status.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }

        if(isBaseScheduleAdded(item.baseSchedule)) {
          if(TEMP_ASSIGNMENT_BASE_SCHEDULE_DONE_MESSAGE.toLocaleLowerCase().includes(searchString.toLowerCase())) {
            return true;
          }
        }
        else {
          if(TEMP_ASSIGNMENT_BASE_SCHEDULE_MISSING_MESSAGE.toLocaleLowerCase().includes(searchString.toLowerCase())) {
            return true;
          }
        }

        return false;
      },
      (result) => {
        applySearchCallback(searchString, result);
      }
    );
    applySearchCallback(searchString, result);
  }
}